module.exports = __webpack_public_path__ + "static/SeeVita-01-d494ddd53f0cced527dbbb7eec43d12e.png";